import { createUseControls } from 'next/components/Listing';

export const { useControls, Search } = createUseControls('pins');
